var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgArrowWhite = function SvgArrowWhite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#fff",
    d: "m20.172 17.868-.002.508.501-.003 2.156-.01.492-.002.003-.499.079-16.7.002-.507-.501.002L6.42.737l-.492.002-.002.499-.01 2.185-.002.508.501-.003 11.593-.056L1.942 20.151l-.351.356.35.356L3.46 22.4l.352.356.35-.356L20.229 6.122l-.056 11.746Z"
  })));
};
export default SvgArrowWhite;